import { useEffect, useMemo } from 'react';
import { EventBus } from '@vtblife/event-bus';
import { LandingEventsManager } from './landing-events-manager';
var eventBus = EventBus.getInstance();
export var useLandingEventsManager = function useLandingEventsManager(requestEventType, responseEventType) {
  var landingEventsManagerInstance = useMemo(function () {
    return new LandingEventsManager(requestEventType, responseEventType, eventBus);
  }, [requestEventType, responseEventType]);
  useEffect(function () {
    return function () {
      return landingEventsManagerInstance.dispose();
    };
  }, [landingEventsManagerInstance]);
  return landingEventsManagerInstance;
};